function a(t, o) {
  const r = RegExp(t, "g");
  return (e) => {
    if (typeof e != "string")
      throw new TypeError(`expected an argument of type string, but got ${typeof e}`);
    return e.match(r) ? e.replace(r, o) : e;
  };
}
export {
  a as default
};
